import NewBrand from "../../../../components/@products/brands/NewBrand";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BrandNewPage() {
    
    return (
        <NewBrand 
            routeType={routeTypes.admin}
        />
    )
}       